<script>
import { Bar, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    var _this = this;
    let option = this.options || {};
    option.onClick=function(event, array) {
              _this.$emit("click", {event, array});
        };
    this.renderChart(this.chartData,option)
  },
}
</script>
